import { vars } from '../vars';
import { buildImgR2Key, type IBuildImgArgs } from './build-img-r2-key';

export function buildImgUrl(args: IBuildImgArgs): string {
  return `${vars.s3.publicBucket.publicUrl}/${buildImgR2Key(args)}`;
}
